var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { GenericComponent } from '../../atoms/GenericComponent';
/**
 * Prevents the table from crashing if a custom value is not a function or
 * if the function throws an error.
 * @param fn
 * @param rowData
 * @param tableData
 * @param globalData
 */
function tryToEval(fn, rowData, tableData, globalData) {
    try {
        // eslint-disable-next-line no-eval
        return fn.includes('function(') ? eval("".concat(fn, "(rowData, tableData, globalData)")) : fn;
    }
    catch (e) {
        console.error(e);
        return fn;
    }
}
/**
 * Transforms data into a format that can be used as props for a component,
 * destructuring nested objects into a flat structure.
 * @param source
 * @param varName
 * @param _baseKey
 * @param nestedProps
 * @param rowData
 * @param tableData
 * @param globalData
 */
function transformData(source, varName, _baseKey, nestedProps, rowData, tableData, globalData) {
    if (nestedProps === void 0) { nestedProps = {}; }
    var isCustomValue = varName === 'customValues';
    var baseKey = isCustomValue && !_baseKey ? 'custom' : _baseKey;
    Object.keys(source).forEach(function (key) {
        var value = isCustomValue
            ? tryToEval(source[key], rowData, tableData, globalData)
            : source[key];
        var newKey = baseKey ? "".concat(baseKey, "[").concat(key, "]") : "".concat(varName, "[").concat(key, "]");
        if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            transformData(value, varName, newKey, nestedProps, rowData, tableData, globalData);
        }
        else {
            nestedProps[newKey] = value;
        }
    });
    return nestedProps;
}
export var TableCell = function (_a) {
    var design = _a.design, cellIndex = _a.cellIndex, _b = _a.tableData, tableData = _b === void 0 ? {} : _b, _c = _a.globalData, globalData = _c === void 0 ? {} : _c, _d = _a.rowData, rowData = _d === void 0 ? {} : _d, rowIndex = _a.rowIndex, innerCellDesign = _a.innerCellDesign, _e = _a.customValues, customValues = _e === void 0 ? {} : _e, extraCellConfiguration = _a.extraCellConfiguration, props = __rest(_a, ["design", "cellIndex", "tableData", "globalData", "rowData", "rowIndex", "innerCellDesign", "customValues", "extraCellConfiguration"]);
    var schema = useDesign(design).schema;
    var _f = innerCellDesign || [], componentInsideCell = _f[0], designForComponentInsideCell = _f[1], configForComponentInsideCell = _f[2];
    var nRowData = transformData(rowData, 'rowData');
    var nGlobalData = transformData(globalData, 'globalData');
    var allData = [undefined, {}, rowData, tableData, nGlobalData];
    var nCustomValues = transformData.apply(void 0, __spreadArray([customValues, 'customValues'], allData, false));
    var valuesProps = __assign(__assign(__assign({ cellIndex: cellIndex, rowIndex: rowIndex }, nRowData), nGlobalData), nCustomValues);
    var _g = valuesProps || {}, _h = _g.props, passingProps = _h === void 0 ? {} : _h, passingConfig = _g.config, values = __rest(_g, ["props", "config"]);
    return (_jsx(GenericComponent, __assign({ schema: schema, as: "td" }, extraCellConfiguration, { children: _jsx(FactoryComponent, __assign({ component: componentInsideCell, design: designForComponentInsideCell }, configForComponentInsideCell, { values: values }, passingProps, { autoIndex: true })) })));
};
TableCell.displayName = 'TableCell';
